import Vue from 'vue'
import Vuex from 'vuex'
import axios from 'axios';
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex)


const store = new Vuex.Store({
  state: {
    API: 'https://www.ugrasu.ru/api/directory/',
    routeInfo: {
      routeName: null,
      routeParam: null,
    },
    searchBG: false,
    groupList: [],
    subGroupList: [],
    kindofworks: [],
    streamList: [],
    buildingsList: [],
    institutsList: [],
    lecturersList: [],
    auditoriumList: [],
    contenttableoflesson: [],
    notification: {},
    device: 'krust',
    favoritesList: null,
  },
  getters: {
    getAPI: state => state.API,
    getRouteInfo: state => state.routeInfo,
    getSearchBG: state => state.searchBG,
    getGroupList: state => state.groupList,
    getSubGroupList: state => state.subGroupList,
    getKindofworks: state => state.kindofworks,
    getStreamList: state => state.streamList,
    getBuildingsList: state => state.buildingsList,
    getInstitutsList: state => state.institutsList,
    getLecturersList: state => state.lecturersList,
    getAuditoriumList: state => state.auditoriumList,
    getContenttableoflesson: state => state.contenttableoflesson,
    getDevice: state => state.device,
    getNotification: state => state.notification,
    getFavoritesList: state => state.favoritesList,
  },
  mutations: {
    setRouteInfo(state,routes){
      state.routeInfo = routes;
    },
    setSearchBG(state,searchBG){
      state.searchBG = searchBG;
    },
    setGroupList(state,groups){
      state.groupList = groups;
    },
    setSubGroupList(state,subgroups){
      state.subGroupList = subgroups;
    },
    setKindofworks(state,works){
      state.kindofworks = works;
    },
    setStreamList(state,streams){
      state.streamList = streams;
    },
    setBuildingsList(state,builds){
      state.buildingsList = builds;
    },
    setInstitutsList(state,instituts){
      state.institutsList = instituts;
    },
    setLecturersList(state,lecturers){
      state.lecturersList = lecturers;
    },
    setAuditoriumList(state,auditorium){
      state.auditoriumList = auditorium;
    },
    setContenttableoflesson(state,tableTime){
      state.contenttableoflesson = tableTime;
    },
    setDevice(state,device){
      state.device = device;
    },
    setNotification(state,notification){
      state.notification = notification;
    },
    setFavoritesList(state,favoritesList){
      state.favoritesList = favoritesList;
    },
  },
  actions: {

  },

  //plugins: [createPersistedState()],

});


export default store;
